// Mirror of server LEVEL_UNLOCKS — keep in sync with server/src/config.ts
// Full unlock table with types: Game, Zone, Feature

export const LEVEL_UNLOCKS = [
  // Level 1
  { level: 1,  unlockId: 'game_blackjack',    type: 'Game',    displayName: 'game_blackjack' },
  // Level 2
  { level: 2,  unlockId: 'game_crash',        type: 'Game',    displayName: 'unlock_crash',             path: '/crash' },
  // Level 8
  { level: 8,  unlockId: 'game_mines',        type: 'Game',    displayName: 'unlock_mines',             path: '/mines' },
  // Level 10
  { level: 10, unlockId: 'game_roulette',     type: 'Game',    displayName: 'game_roulette' },
  // Level 12
  { level: 12, unlockId: 'game_tower',        type: 'Game',    displayName: 'unlock_tower',             path: '/tower' },
  // Level 15
  { level: 15, unlockId: 'game_chicken',      type: 'Game',    displayName: 'unlock_chicken_cross',     path: '/chicken' },
];

// unlockId -> required level
export const UNLOCK_LEVEL_MAP = {};
for (const u of LEVEL_UNLOCKS) {
  UNLOCK_LEVEL_MAP[u.unlockId] = u.level;
}

// path -> unlockId (only for unlocks that have a route path)
export const PATH_TO_UNLOCK = {};
for (const u of LEVEL_UNLOCKS) {
  if (u.path) PATH_TO_UNLOCK[u.path] = u.unlockId;
}

// Tier color based on level
export function getTierColor(level) {
  if (level >= 100) return '#e04848'; // legendary red + particles
  if (level >= 50) return '#e04848';  // red
  if (level >= 40) return '#eab308';  // gold
  if (level >= 30) return '#a855f7';  // purple
  if (level >= 20) return '#c08515';  // gold
  if (level >= 10) return '#4caf50';  // green
  return '#9ca3af'; // gray
}

export function getTierName(level) {
  if (level >= 100) return 'Legendary';
  if (level >= 50) return 'Legend';
  if (level >= 40) return 'Gold';
  if (level >= 30) return 'Purple';
  if (level >= 20) return 'Blue';
  if (level >= 10) return 'Green';
  return 'Gray';
}
